import React, { Button, Grid, styled } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useProfilePlaceholder } from 'hooks';
import { ImageUploaderProps } from './ImageUploaderProps';
import { createRef, MouseEventHandler } from 'react';

const Input = styled('input')({
	display: 'none',
});

export const ImageUploader = ({ base64Image }: ImageUploaderProps) => {
	const methods = useFormContext();
	const defaultImage = useProfilePlaceholder();
	const imageUrl = base64Image ?? defaultImage;
	const inputRef = createRef<HTMLInputElement>();
    const onClick: MouseEventHandler<HTMLButtonElement> = (event) => {
        event.preventDefault();
        event.stopPropagation();
        inputRef?.current?.click();
        return false;
    }
	return (
		<Grid container>
			<Grid item xs={6}>
				{imageUrl && <img src={imageUrl} alt='Profile' style={{ width: '100px', height: '100px', borderRadius: '50%' }} />}
			</Grid>
			<Grid item xs={6}>
				<label htmlFor='file-upload'>
					<Input
						id='file-upload'
						type='file'
						accept='image/*'
						ref={inputRef}
						onChange={event => {
							const file = event.target.files?.[0];
							if (file) {
								const reader = new FileReader();
								reader.onloadend = () => {
									const imageUrl = reader.result as string;
									methods.setValue('imageUrl', imageUrl);
								};
								reader.readAsDataURL(file);
							}
						}}
					/>
					<Button
						variant="contained"
						component="span"
						color="primary"
						onClick={onClick}
					>
						Upload Image
					</Button>
				</label>
			</Grid>
		</Grid >
	);
};
